import { FunctionComponent, PropsWithChildren, ReactElement, SyntheticEvent } from 'react';
import { Box, Button } from '@bridebook/ui';
import CustomClickLink from '@bridebook/web/app-shared/components/custom-click-link/custom-click-link';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import componentStyles from './sidebar-section.style';

interface IProps {
  title: string;
  subtitle?: string;
  subtitleIcon?: ReactElement;
  subtitleLink?: string;
  onButtonClick?: (e: SyntheticEvent<any, Event>) => any;
  buttonText?: string;
  onSubtitleLinkClick?: () => void;
}

const SidebarSection: FunctionComponent<PropsWithChildren<IProps>> = ({
  title,
  subtitle,
  subtitleIcon,
  children,
  onButtonClick,
  buttonText,
  subtitleLink,
  onSubtitleLinkClick,
}) => {
  const showSubtitle = !!(subtitle && subtitleLink);
  const styles = componentStyles({ showSubtitle });

  return (
    <Box style={styles.wrapper}>
      <Box as="h4" style={styles.title}>
        {title}
      </Box>
      {showSubtitle && (
        <Box style={styles.subtitleWrapOuter}>
          <Link href={subtitleLink || ''} passHref legacyBehavior>
            <CustomClickLink onCustomClick={onSubtitleLinkClick}>
              <Box style={styles.subtitleWrap}>
                {subtitleIcon && <Box style={styles.subtitleIconWrap}>{subtitleIcon}</Box>}
                <Box>{subtitle}</Box>
              </Box>
            </CustomClickLink>
          </Link>
        </Box>
      )}
      <Box style={styles.content}>{children}</Box>
      {onButtonClick && buttonText && (
        <Box style={styles.buttonWrap}>
          <Button theme="ghost" text={buttonText} onClick={onButtonClick} />
        </Box>
      )}
    </Box>
  );
};

export default SidebarSection;
